module.exports = __webpack_public_path__ + "img/dynamic-13.3997d844.png";